// Kaffa Exchange test IDs
export const KAFFA = {
  // Header
  headerLogo: 'kaffa-header-logo',
  navMarketplace: 'kaffa-nav-marketplace',
  navAbout: 'kaffa-nav-about',
  navLogin: 'kaffa-nav-login',
  navRegister: 'kaffa-nav-register',
  themeToggle: 'kaffa-theme-toggle',
  langSelect: 'kaffa-lang-select',
  currencySelect: 'kaffa-currency-select',
  userMenu: 'kaffa-user-menu',
  logoutBtn: 'kaffa-logout-btn',
  alertsBell: 'kaffa-alerts-bell',
  alertsPanel: 'kaffa-alerts-panel',

  // Marketplace
  searchInput: 'kaffa-search-input',
  filterCoffeeType: 'kaffa-filter-coffee-type',
  filterProcess: 'kaffa-filter-process',
  filterRegion: 'kaffa-filter-region',
  lotCard: 'kaffa-lot-card',
  lotCardLink: 'kaffa-lot-card-link',
  ctaLogin: 'kaffa-cta-login',
  ctaRegister: 'kaffa-cta-register',

  // Auth
  loginEmail: 'login-email',
  loginPassword: 'login-password',
  loginSubmit: 'login-submit',
  registerRazaoSocial: 'register-razao-social',
  registerCnpj: 'register-cnpj',
  registerAddress: 'register-address',
  registerPhone: 'register-phone',
  registerEmail: 'register-email',
  registerCountry: 'register-country',
  registerCommercial: 'register-commercial',
  registerPassword: 'register-password',
  registerSubmit: 'register-submit',

  // Lot detail
  lotTitle: 'lot-title',
  lotPrice: 'lot-price',
  lotInterestBtn: 'lot-interest-btn',
  lotProposalBtn: 'lot-proposal-btn',
  proposalPriceInput: 'proposal-price-input',
  proposalBagsInput: 'proposal-bags-input',
  proposalMessage: 'proposal-message',
  proposalSubmit: 'proposal-submit',

  // Cooperative dashboard
  coopCreateLot: 'coop-create-lot',
  coopLotEdit: 'coop-lot-edit',
  coopLotPause: 'coop-lot-pause',
  coopLotDelete: 'coop-lot-delete',
  coopAutoPriceToggle: 'coop-auto-price-toggle',
  coopMarginInput: 'coop-margin-input',
  coopProposalAccept: 'coop-proposal-accept',
  coopProposalReject: 'coop-proposal-reject',
  coopProposalCounter: 'coop-proposal-counter',

  // Admin
  adminApproveUser: 'admin-approve-user',
  adminRejectUser: 'admin-reject-user',
  adminCreateCoop: 'admin-create-coop',
  adminIndicatorSave: 'admin-indicator-save',

  // Lot form
  lotFormName: 'lot-form-name',
  lotFormBags: 'lot-form-bags',
  lotFormPrice: 'lot-form-price',
  lotFormSubmit: 'lot-form-submit',
};
